import { LeadActivityType } from "views/leads-id/types";

export const LEAD_ACTIVITY_TYPE_LABELS: Record<LeadActivityType, string> = {
  lead_created_by_user: "Lead created",
  lead_created_auto: "Lead created (auto)",
  lead_details_edited: "Details edited",
  file_uploaded: "File uploaded",
  file_deleted: "File deleted",
  note_added: "Note added",
  email_invite_sent: "Invited to apply",
  stage_changed_manual: "Stage changed",
  stage_changed_auto: "Stage changed",
  identity_verification_passed: "IDV passed",
  identity_verification_passed_with_warnings: "IDV passed with warnings",
  identity_verification_failed: "IDV failed",
  identity_verification_overridden: "IDV overridden",
  lead_assigned: "Lead assigned",
  identity_verification_data_edited: "IDV data edited",
  prescreening_submitted: "Prescreening submitted",
  prescreening_failed: "Prescreening failed",
  prescreening_completed: "Prescreening submitted",
  prescreening_abandoned: "Prescreening abandoned",
  email_received: "Email received",
  email_sent: "Email sent",
  sms_received: "SMS received",
  sms_sent: "SMS sent",
  sms_not_sent: "SMS not sent",
  manual_record: "Manual record",
  showing_invite_sent: "Showing invite sent",
  showing_requested: "Showing requested",
  showing_scheduled: "Showing scheduled",
  showing_confirmed: "Showing confirmed",
  ai_call_received: "AI call received",
  outbound_call_placed: "Outbound call placed",
  inbound_call_received: "Incoming call received",
  inbound_call_forwarded: "Incoming call forwarded",
  inbound_call_forward_failed: "Call forward unsuccessful",
  inbound_call_text_only: "Incoming call not answered",
  showing_rescheduled: "Showing rescheduled",
  showing_checked_in: "Checked in to showing",
  showing_checked_out: "Checked out of showing",
  showing_feedback_submitted: "Showing feedback submitted",
  showing_lockbox_not_configured: "Check-in skipped: lockbox not configured",
  showing_cancelled: "Showing cancelled",
  showing_reassigned: "Showing reassigned",
  showing_completed: "Showing completed",
  showing_no_show: "Showing no-show",
  showing_guided_confirmed: "Showing attendance confirmed",
  showing_serial_number_incorrect: "Incorrect lockbox serial number",
  showing_serial_number_lockout: "Locked out of self-guided check-in",
  tenant_notified_of_showing: "Tenant notified of showing",
  push_lead_to_pms_success: "Pushed to PMS",
  push_lead_to_pms_failed: "PMS push failed"
};
